import React, { useEffect, useState } from "react";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { eye } from "react-icons-kit/feather/eye";
import LoginDesktop from "../LoginDesktop";
import { Link } from "react-router-dom";
import AccountStatementComponent from "../Accounts/AccountStatementComponent";
import BalanceOverviewComponent from "../Accounts/BalanceOverviewComponent";
import BetHistoryComponent from "../Accounts/BetHistoryComponent";
import LogOutComponent from "../Accounts/LogOutComponent";
import MyProfileComponent from "../Accounts/MyProfileComponent";
import { useDispatch, useSelector } from "react-redux";
import { handelLogout } from "../../../store/features/auth/authSlice";
import MobileLogin from "../MobileLogin";

const Header = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    // Add event listener to handle window resize
    window.addEventListener("resize", handleResize);

    // Call the handleResize function initially to set the initial state
    handleResize();

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSignup = () => {
    // Handle button click event
  };

  const [showPassword, setShowPassword] = useState("password");
  const [icon, setIcon] = useState(eyeOff);
  const [random, setRandomNumber] = useState(0);
  const [showLogin, setShowLogin] = useState(false);
  const { login } = useSelector((state) => state.auth);

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const options = [
    { name: "My Profile", path: "/my-profile" },
    { name: "Balance Overview", path: "/balance-overview" },
    { name: "Account Statement", path: "/account-statement" },
    { name: "Bet History", path: "/bet-history" },
    { name: "Log Out", path: "/log-out" },
  ];

  const dispatch = useDispatch();

  // const handleDropDown = (option) => {
  //   setSelectedOption(option);
  //   setIsOpen(false);
  // };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  function handleButtonClick() {
    setShowLogin(true);
  }
  const togglePass = () => {
    if (showPassword === "password") {
      setIcon(eye);
      setShowPassword("text");
    } else {
      setIcon(eyeOff);
      setShowPassword("password");
    }
  };

  const ShowRandomNumber = () => {
    setRandomNumber(
      (Math.floor(Math.random() * 10000) + 10000).toString().substring(1)
    );
  };

  useEffect(() => {
    ShowRandomNumber();
  }, []);

  return (
    <>
      <div className=" ">
        
      </div>
    </>
  );
};

export default Header;
